import React from 'react';
import { PopoverPosition } from '@mui/material';


export const useMousePositionedPopover = () => {
  const mousePositionRef = React.useRef({ left: 0, top: 0 });
  const [ popoverMenuTarget, setPopoverMenuTarget ] = React.useState<PopoverPosition>();

  React.useEffect(() => {
    const handler = (e: MouseEvent) => {
      mousePositionRef.current.left = e.clientX;
      mousePositionRef.current.top = e.clientY;
    };

    window.addEventListener('mousemove', handler);

    return () => window.removeEventListener('mousemove', handler);
  }, []);

  const showPopover = () => setPopoverMenuTarget({ ...mousePositionRef.current });
  const closePopover = () => setPopoverMenuTarget(undefined);

  return [ popoverMenuTarget, showPopover, closePopover ] as const;
};
